export default class CaseStudies {
  static setupCards = () => {
    $(document).ready(() => {
      $('[data-link]').click((event) => {
        window.location.href = $(event.currentTarget).attr('data-link')
      })
    })
  }
}
